
export interface ServiceInfo {
    name: string;
    uuid: string;
    spec?: string;
}

const egzotechServices = [
    { name: "MsgPack", uuid: "00000040-6567-7a6f-7465-63682e636f6d" }
];

export const defaultServices: ServiceInfo[] = [
    { name: "Generic Access", uuid: "0x1800", spec: "GSS" },
    { name: "Alert Notification Service", uuid: "0x1811", spec: "GSS" },
    { name: "Automation IO", uuid: "0x1815", spec: "GSS" },
    { name: "Battery Service", uuid: "0x180F", spec: "GSS" },
    { name: "Binary Sensor", uuid: "0x183B", spec: "BSS" },
    { name: "Blood Pressure", uuid: "0x1810", spec: "GSS" },
    { name: "Body Composition", uuid: "0x181B", spec: "GSS" },
    { name: "Bond Management Service", uuid: "0x181E", spec: "GSS" },
    { name: "Continuous Glucose Monitoring", uuid: "0x181F", spec: "GSS" },
    { name: "Current Time Service", uuid: "0x1805", spec: "GSS" },
    { name: "Cycling Power", uuid: "0x1818", spec: "GSS" },
    { name: "Cycling Speed and Cadence", uuid: "0x1816", spec: "GSS" },
    { name: "Device Information", uuid: "0x180A", spec: "GSS" },
    { name: "Emergency Configuration", uuid: "0x183C", spec: "EMCS" },
    { name: "Environmental Sensing", uuid: "0x181A", spec: "GSS" },
    { name: "Fitness Machine", uuid: "0x1826", spec: "GSS" },
    { name: "Generic Attribute", uuid: "0x1801", spec: "GSS" },
    { name: "Glucose", uuid: "0x1808", spec: "GSS" },
    { name: "Health Thermometer", uuid: "0x1809", spec: "GSS" },
    { name: "Heart Rate", uuid: "0x180D", spec: "GSS" },
    { name: "HTTP Proxy", uuid: "0x1823", spec: "GSS" },
    { name: "Human Interface Device", uuid: "0x1812", spec: "GSS" },
    { name: "Immediate Alert", uuid: "0x1802", spec: "GSS" },
    { name: "Indoor Positioning", uuid: "0x1821", spec: "GSS" },
    { name: "Insulin Delivery", uuid: "0x183A", spec: "GSS" },
    { name: "Internet Protocol Support Service", uuid: "0x1820", spec: "GSS" },
    { name: "Link Loss", uuid: "0x1803", spec: "GSS" },
    { name: "Location and Navigation", uuid: "0x1819", spec: "GSS" },
    { name: "Mesh Provisioning Service", uuid: "0x1827", spec: "GSS" },
    { name: "Mesh Proxy Service", uuid: "0x1828", spec: "GSS" },
    { name: "Next DST Change Service", uuid: "0x1807", spec: "GSS" },
    { name: "Object Transfer Service", uuid: "0x1825", spec: "GSS" },
    { name: "Phone Alert Status Service", uuid: "0x180E", spec: "GSS" },
    { name: "Pulse Oximeter Service", uuid: "0x1822", spec: "GSS" },
    { name: "Reconnection Configuration", uuid: "0x1829", spec: "GSS" },
    { name: "Reference Time Update Service", uuid: "0x1806", spec: "GSS" },
    { name: "Running Speed and Cadence", uuid: "0x1814", spec: "GSS" },
    { name: "Scan Parameters", uuid: "0x1813", spec: "GSS" },
    { name: "Transport Discovery", uuid: "0x1824", spec: "GSS" },
    { name: "Tx Power", uuid: "0x1804", spec: "GSS" },
    { name: "User Data", uuid: "0x181C", spec: "GSS" },
    { name: "Weight Scale", uuid: "0x181D", spec: "GSS" },
    ...egzotechServices
]

export interface CharacteristicInfo {
    name: string;
    uuid: string;
    spec?: string;
}

const egzotechCharacteristics = [
    { name: "Streaming", uuid: "00000041-6567-7a6f-7465-63682e636f6d" }
];

export const defaultCharacteristics: CharacteristicInfo[] = [
    { name: "Aerobic Heart Rate Lower Limit", uuid: "0x2A7E", spec: "GSS" },
    { name: "Aerobic Heart Rate Upper Limit", uuid: "0x2A84", spec: "GSS" },
    { name: "Aerobic Threshold", uuid: "0x2A7F", spec: "GSS" },
    { name: "Age", uuid: "0x2A80", spec: "GSS" },
    { name: "Aggregate", uuid: "0x2A5A", spec: "GSS" },
    { name: "Alert Category ID", uuid: "0x2A43", spec: "GSS" },
    { name: "Alert Category ID Bit Mask", uuid: "0x2A42", spec: "GSS" },
    { name: "Alert Level", uuid: "0x2A06", spec: "GSS" },
    { name: "Alert Notification Control Point", uuid: "0x2A44", spec: "GSS" },
    { name: "Alert Status", uuid: "0x2A3F", spec: "GSS" },
    { name: "Altitude", uuid: "0x2AB3", spec: "GSS" },
    { name: "Anaerobic Heart Rate Lower Limit", uuid: "0x2A81", spec: "GSS" },
    { name: "Anaerobic Heart Rate Upper Limit", uuid: "0x2A82", spec: "GSS" },
    { name: "Anaerobic Threshold", uuid: "0x2A83", spec: "GSS" },
    { name: "Analog", uuid: "0x2A58", spec: "GSS" },
    { name: "Analog Output", uuid: "0x2A59", spec: "GSS" },
    { name: "Apparent Wind Direction", uuid: "0x2A73", spec: "GSS" },
    { name: "Apparent Wind Speed", uuid: "0x2A72", spec: "GSS" },
    { name: "Appearance", uuid: "0x2A01", spec: "Core 4.0" },
    { name: "Barometric Pressure Trend", uuid: "0x2AA3", spec: "GSS" },
    { name: "Battery Level", uuid: "0x2A19", spec: "GSS" },
    { name: "Battery Level State", uuid: "0x2A1B", spec: "GSS" },
    { name: "Battery Power State", uuid: "0x2A1A", spec: "GSS" },
    { name: "Blood Pressure Feature", uuid: "0x2A49", spec: "GSS" },
    { name: "Blood Pressure Measurement", uuid: "0x2A35", spec: "GSS" },
    { name: "Body Composition Feature", uuid: "0x2A9B", spec: "GSS" },
    { name: "Body Composition Measurement", uuid: "0x2A9C", spec: "GSS" },
    { name: "Body Sensor Location", uuid: "0x2A38", spec: "GSS" },
    { name: "Bond Management Control Point", uuid: "0x2AA4", spec: "GSS" },
    { name: "Bond Management Features", uuid: "0x2AA5", spec: "GSS" },
    { name: "Boot Keyboard Input Report", uuid: "0x2A22", spec: "GSS" },
    { name: "Boot Keyboard Output Report", uuid: "0x2A32", spec: "GSS" },
    { name: "Boot Mouse Input Report", uuid: "0x2A33", spec: "GSS" },
    { name: "BSS Control Point", uuid: "0x2B2B", spec: "BSS" },
    { name: "BSS Response", uuid: "0x2B2C", spec: "BSS" },
    { name: "CGM Feature", uuid: "0x2AA8", spec: "GSS" },
    { name: "CGM Measurement", uuid: "0x2AA7", spec: "GSS" },
    { name: "CGM Session Run Time", uuid: "0x2AAB", spec: "GSS" },
    { name: "CGM Session Start Time", uuid: "0x2AAA", spec: "GSS" },
    { name: "CGM Specific Ops Control Point", uuid: "0x2AAC", spec: "GSS" },
    { name: "CGM Status", uuid: "0x2AA9", spec: "GSS" },
    { name: "Client Supported Features", uuid: "0x2B29", spec: "Core 5.1" },
    { name: "Cross Trainer Data", uuid: "0x2ACE", spec: "GSS" },
    { name: "CSC Feature", uuid: "0x2A5C", spec: "GSS" },
    { name: "CSC Measurement", uuid: "0x2A5B", spec: "GSS" },
    { name: "Current Time", uuid: "0x2A2B", spec: "GSS" },
    { name: "Cycling Power Control Point", uuid: "0x2A66", spec: "GSS" },
    { name: "Cycling Power Feature", uuid: "0x2A65", spec: "GSS" },
    { name: "Cycling Power Measurement", uuid: "0x2A63", spec: "GSS" },
    { name: "Cycling Power Vector", uuid: "0x2A64", spec: "GSS" },
    { name: "Database Change Increment", uuid: "0x2A99", spec: "GSS" },
    { name: "Database Hash", uuid: "0x2B2A", spec: "Core 5.1 or later" },
    { name: "Date of Birth", uuid: "0x2A85", spec: "GSS" },
    { name: "Date of Threshold Assessment", uuid: "0x2A86", spec: "GSS" },
    { name: "Date Time", uuid: "0x2A08", spec: "GSS" },
    { name: "Date UTC", uuid: "0x2AED", spec: "GSS" },
    { name: "Day Date Time", uuid: "0x2A0A", spec: "GSS" },
    { name: "Day of Week", uuid: "0x2A09", spec: "GSS" },
    { name: "Descriptor Value Changed", uuid: "0x2A7D", spec: "GSS" },
    { name: "Dew Point", uuid: "0x2A7B", spec: "GSS" },
    { name: "Digital", uuid: "0x2A56", spec: "GSS" },
    { name: "Digital Output", uuid: "0x2A57", spec: "GSS" },
    { name: "DST Offset", uuid: "0x2A0D", spec: "GSS" },
    { name: "Elevation", uuid: "0x2A6C", spec: "GSS" },
    { name: "Email Address", uuid: "0x2A87", spec: "GSS" },
    { name: "Emergency ID", uuid: "0x2B2D", spec: "EMCS" },
    { name: "Emergency Text", uuid: "0x2B2E", spec: "EMCS" },
    { name: "Exact Time 100", uuid: "0x2A0B", spec: "GSS" },
    { name: "Exact Time 256", uuid: "0x2A0C", spec: "GSS" },
    { name: "Fat Burn Heart Rate Lower Limit", uuid: "0x2A88", spec: "GSS" },
    { name: "Fat Burn Heart Rate Upper Limit", uuid: "0x2A89", spec: "GSS" },
    { name: "Firmware Revision String", uuid: "0x2A26", spec: "GSS" },
    { name: "First Name", uuid: "0x2A8A", spec: "GSS" },
    { name: "Fitness Machine Control Point", uuid: "0x2AD9", spec: "GSS" },
    { name: "Fitness Machine Feature", uuid: "0x2ACC", spec: "GSS" },
    { name: "Fitness Machine Status", uuid: "0x2ADA", spec: "GSS" },
    { name: "Five Zone Heart Rate Limits", uuid: "0x2A8B", spec: "GSS" },
    { name: "Floor Number", uuid: "0x2AB2", spec: "GSS" },
    { name: "Central Address Resolution", uuid: "0x2AA6", spec: "Core 4.2" },
    { name: "Device Name", uuid: "0x2A00", spec: "Core 4.0" },
    { name: "Peripheral Preferred Connection Parameters", uuid: "0x2A04", spec: "Core 4.0" },
    { name: "Peripheral Privacy Flag", uuid: "0x2A02", spec: "Core 4.0" },
    { name: "Reconnection Address", uuid: "0x2A03", spec: "Core 4.0" },
    { name: "Service Changed", uuid: "0x2A05", spec: "Core 4.0" },
    { name: "Gender", uuid: "0x2A8C", spec: "GSS" },
    { name: "Glucose Feature", uuid: "0x2A51", spec: "GSS" },
    { name: "Glucose Measurement", uuid: "0x2A18", spec: "GSS" },
    { name: "Glucose Measurement Context", uuid: "0x2A34", spec: "GSS" },
    { name: "Gust Factor", uuid: "0x2A74", spec: "GSS" },
    { name: "Hardware Revision String", uuid: "0x2A27", spec: "GSS" },
    { name: "Heart Rate Control Point", uuid: "0x2A39", spec: "GSS" },
    { name: "Heart Rate Max", uuid: "0x2A8D", spec: "GSS" },
    { name: "Heart Rate Measurement", uuid: "0x2A37", spec: "GSS" },
    { name: "Heat Index", uuid: "0x2A7A", spec: "GSS" },
    { name: "Height", uuid: "0x2A8E", spec: "GSS" },
    { name: "HID Control Point", uuid: "0x2A4C", spec: "GSS" },
    { name: "HID Information", uuid: "0x2A4A", spec: "GSS" },
    { name: "Hip Circumference", uuid: "0x2A8F", spec: "GSS" },
    { name: "HTTP Control Point", uuid: "0x2ABA", spec: "GSS" },
    { name: "HTTP Entity Body", uuid: "0x2AB9", spec: "GSS" },
    { name: "HTTP Headers", uuid: "0x2AB7", spec: "GSS" },
    { name: "HTTP Status Code", uuid: "0x2AB8", spec: "GSS" },
    { name: "HTTPS Security", uuid: "0x2ABB", spec: "GSS" },
    { name: "Humidity", uuid: "0x2A6F", spec: "GSS" },
    { name: "IDD Annunciation Status", uuid: "0x2B22", spec: "GSS" },
    { name: "IDD Command Control Point", uuid: "0x2B25", spec: "GSS" },
    { name: "IDD Command Data", uuid: "0x2B26", spec: "GSS" },
    { name: "IDD Features", uuid: "0x2B23", spec: "GSS" },
    { name: "IDD History Data", uuid: "0x2B28", spec: "GSS" },
    { name: "IDD Record Access Control Point", uuid: "0x2B27", spec: "GSS" },
    { name: "IDD Status", uuid: "0x2B21", spec: "GSS" },
    { name: "IDD Status Changed", uuid: "0x2B20", spec: "GSS" },
    { name: "IDD Status Reader Control Point", uuid: "0x2B24", spec: "GSS" },
    { name: "IEEE 11073-20601 Regulatory Certification Data List", uuid: "0x2A2A", spec: "GSS" },
    { name: "Indoor Bike Data", uuid: "0x2AD2", spec: "GSS" },
    { name: "Indoor Positioning Configuration", uuid: "0x2AAD", spec: "GSS" },
    { name: "Intermediate Cuff Pressure", uuid: "0x2A36", spec: "GSS" },
    { name: "Intermediate Temperature", uuid: "0x2A1E", spec: "GSS" },
    { name: "Irradiance", uuid: "0x2A77", spec: "GSS" },
    { name: "Language", uuid: "0x2AA2", spec: "GSS" },
    { name: "Last Name", uuid: "0x2A90", spec: "GSS" },
    { name: "Latitude", uuid: "0x2AAE", spec: "GSS" },
    { name: "LN Control Point", uuid: "0x2A6B", spec: "GSS" },
    { name: "LN Feature", uuid: "0x2A6A", spec: "GSS" },
    { name: "Local East Coordinate", uuid: "0x2AB1", spec: "GSS" },
    { name: "Local North Coordinate", uuid: "0x2AB0", spec: "GSS" },
    { name: "Local Time Information", uuid: "0x2A0F", spec: "GSS" },
    { name: "Location and Speed Characteristic", uuid: "0x2A67", spec: "GSS" },
    { name: "Location Name", uuid: "0x2AB5", spec: "GSS" },
    { name: "Longitude", uuid: "0x2AAF", spec: "GSS" },
    { name: "Magnetic Declination", uuid: "0x2A2C", spec: "GSS" },
    { name: "Magnetic Flux Density – 2D", uuid: "0x2AA0", spec: "GSS" },
    { name: "Magnetic Flux Density – 3D", uuid: "0x2AA1", spec: "GSS" },
    { name: "Manufacturer Name String", uuid: "0x2A29", spec: "GSS" },
    { name: "Maximum Recommended Heart Rate", uuid: "0x2A91", spec: "GSS" },
    { name: "Measurement Interval", uuid: "0x2A21", spec: "GSS" },
    { name: "Mesh Provisioning Data In", uuid: "0x2ADB", spec: "Mesh Profile 1.0" },
    { name: "Mesh Provisioning Data Out", uuid: "0X2ADC", spec: "Mesh Profile 1.0" },
    { name: "Mesh Proxy Data In", uuid: "0X2ADD", spec: "Mesh Profile 1.0" },
    { name: "Mesh Proxy Data Out", uuid: "0X2ADE", spec: "Mesh Profile 1.0" },
    { name: "Model Number String", uuid: "0x2A24", spec: "GSS" },
    { name: "Navigation", uuid: "0x2A68", spec: "GSS" },
    { name: "Network Availability", uuid: "0x2A3E", spec: "GSS" },
    { name: "New Alert", uuid: "0x2A46", spec: "GSS" },
    { name: "Object Action Control Point", uuid: "0x2AC5", spec: "GSS" },
    { name: "Object Changed", uuid: "0x2AC8", spec: "GSS" },
    { name: "Object First-Created", uuid: "0x2AC1", spec: "GSS" },
    { name: "Object ID", uuid: "0x2AC3", spec: "GSS" },
    { name: "Object Last-Modified", uuid: "0x2AC2", spec: "GSS" },
    { name: "Object List Control Point", uuid: "0x2AC6", spec: "GSS" },
    { name: "Object List Filter", uuid: "0x2AC7", spec: "GSS" },
    { name: "Object Name", uuid: "0x2ABE", spec: "GSS" },
    { name: "Object Properties", uuid: "0x2AC4", spec: "GSS" },
    { name: "Object Size", uuid: "0x2AC0", spec: "GSS" },
    { name: "Object Type", uuid: "0x2ABF", spec: "GSS" },
    { name: "OTS Feature", uuid: "0x2ABD", spec: "GSS" },
    { name: "PLX Continuous Measurement Characteristic", uuid: "0x2A5F", spec: "GSS" },
    { name: "PLX Features", uuid: "0x2A60", spec: "GSS" },
    { name: "PLX Spot-Check Measurement", uuid: "0x2A5E", spec: "GSS" },
    { name: "PnP ID", uuid: "0x2A50", spec: "GSS" },
    { name: "Pollen Concentration", uuid: "0x2A75", spec: "GSS" },
    { name: "Position 2D", uuid: "0x2A2F", spec: "GSS" },
    { name: "Position 3D", uuid: "0x2A30", spec: "GSS" },
    { name: "Position Quality", uuid: "0x2A69", spec: "GSS" },
    { name: "Pressure", uuid: "0x2A6D", spec: "GSS" },
    { name: "Protocol Mode", uuid: "0x2A4E", spec: "GSS" },
    { name: "Pulse Oximetry Control Point", uuid: "0x2A62", spec: "GSS" },
    { name: "Rainfall", uuid: "0x2A78", spec: "GSS" },
    { name: "RC Feature", uuid: "0x2B1D", spec: "GSS" },
    { name: "RC Settings", uuid: "0x2B1E", spec: "GSS" },
    { name: "Reconnection Configuration Control Point", uuid: "0x2B1F", spec: "GSS" },
    { name: "Record Access Control Point", uuid: "0x2A52", spec: "GSS" },
    { name: "Reference Time Information", uuid: "0x2A14", spec: "GSS" },
    { name: "Registered User Characteristic", uuid: "0x2B37", spec: "UDS 1.1" },
    { name: "Removable", uuid: "0x2A3A", spec: "GSS" },
    { name: "Report", uuid: "0x2A4D", spec: "GSS" },
    { name: "Report Map", uuid: "0x2A4B", spec: "GSS" },
    { name: "Resolvable Private Address Only", uuid: "0x2AC9", spec: "Core 5.0" },
    { name: "Resting Heart Rate", uuid: "0x2A92", spec: "GSS" },
    { name: "Ringer Control point", uuid: "0x2A40", spec: "GSS" },
    { name: "Ringer Setting", uuid: "0x2A41", spec: "GSS" },
    { name: "Rower Data", uuid: "0x2AD1", spec: "GSS" },
    { name: "RSC Feature", uuid: "0x2A54", spec: "GSS" },
    { name: "RSC Measurement", uuid: "0x2A53", spec: "GSS" },
    { name: "SC Control Point", uuid: "0x2A55", spec: "GSS" },
    { name: "Scan Interval Window", uuid: "0x2A4F", spec: "GSS" },
    { name: "Scan Refresh", uuid: "0x2A31", spec: "GSS" },
    { name: "Scientific Temperature Celsius", uuid: "0x2A3C", spec: "GSS" },
    { name: "Secondary Time Zone", uuid: "0x2A10", spec: "GSS" },
    { name: "Sensor Location", uuid: "0x2A5D", spec: "GSS" },
    { name: "Serial Number String", uuid: "0x2A25", spec: "GSS" },
    { name: "Server Supported Features", uuid: "0x2B3A", spec: "Core 5.2" },
    { name: "Service Required", uuid: "0x2A3B", spec: "GSS" },
    { name: "Software Revision String", uuid: "0x2A28", spec: "GSS" },
    { name: "Sport Type for Aerobic and Anaerobic Thresholds", uuid: "0x2A93", spec: "GSS" },
    { name: "Stair Climber Data", uuid: "0x2AD0", spec: "GSS" },
    { name: "Step Climber Data", uuid: "0x2ACF", spec: "GSS" },
    { name: "String", uuid: "0x2A3D", spec: "GSS" },
    { name: "Supported Heart Rate Range", uuid: "0x2AD7", spec: "GSS" },
    { name: "Supported Inclination Range", uuid: "0x2AD5", spec: "GSS" },
    { name: "Supported New Alert Category", uuid: "0x2A47", spec: "GSS" },
    { name: "Supported Power Range", uuid: "0x2AD8", spec: "GSS" },
    { name: "Supported Resistance Level Range", uuid: "0x2AD6", spec: "GSS" },
    { name: "Supported Speed Range", uuid: "0x2AD4", spec: "GSS" },
    { name: "Supported Unread Alert Category", uuid: "0x2A48", spec: "GSS" },
    { name: "System ID", uuid: "0x2A23", spec: "GSS" },
    { name: "TDS Control Point", uuid: "0x2ABC", spec: "GSS" },
    { name: "Temperature", uuid: "0x2A6E", spec: "GSS" },
    { name: "Temperature Celsius", uuid: "0x2A1F", spec: "GSS" },
    { name: "Temperature Fahrenheit", uuid: "0x2A20", spec: "GSS" },
    { name: "Temperature Measurement", uuid: "0x2A1C", spec: "GSS" },
    { name: "Temperature Type", uuid: "0x2A1D", spec: "GSS" },
    { name: "Three Zone Heart Rate Limits", uuid: "0x2A94", spec: "GSS" },
    { name: "Time Accuracy", uuid: "0x2A12", spec: "GSS" },
    { name: "Time Broadcast", uuid: "0x2A15", spec: "GSS" },
    { name: "Time Source", uuid: "0x2A13", spec: "GSS" },
    { name: "Time Update Control Point", uuid: "0x2A16", spec: "GSS" },
    { name: "Time Update State", uuid: "0x2A17", spec: "GSS" },
    { name: "Time with DST", uuid: "0x2A11", spec: "GSS" },
    { name: "Time Zone", uuid: "0x2A0E", spec: "GSS" },
    { name: "Training Status", uuid: "0x2AD3", spec: "GSS" },
    { name: "Treadmill Data", uuid: "0x2ACD", spec: "GSS" },
    { name: "True Wind Direction", uuid: "0x2A71", spec: "GSS" },
    { name: "True Wind Speed", uuid: "0x2A70", spec: "GSS" },
    { name: "Two Zone Heart Rate Limit", uuid: "0x2A95", spec: "GSS" },
    { name: "Tx Power Level", uuid: "0x2A07", spec: "GSS" },
    { name: "Uncertainty", uuid: "0x2AB4", spec: "GSS" },
    { name: "Unread Alert Status", uuid: "0x2A45", spec: "GSS" },
    { name: "URI", uuid: "0x2AB6", spec: "GSS" },
    { name: "User Control Point", uuid: "0x2A9F", spec: "GSS" },
    { name: "User Index", uuid: "0x2A9A", spec: "GSS" },
    { name: "UV Index", uuid: "0x2A76", spec: "GSS" },
    { name: "VO2 Max", uuid: "0x2A96", spec: "GSS" },
    { name: "Waist Circumference", uuid: "0x2A97", spec: "GSS" },
    { name: "Weight", uuid: "0x2A98", spec: "GSS" },
    { name: "Weight Measurement", uuid: "0x2A9D", spec: "GSS" },
    { name: "Weight Scale Feature", uuid: "0x2A9E", spec: "GSS" },
    { name: "Wind Chill", uuid: "0x2A79", spec: "GSS" },
    ...egzotechCharacteristics
];
